import React, { useEffect, useState } from 'react';
import {
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
} from '@ionic/react';
import { getKey } from '../utilities/Storage';
import {
  getUpdates,
} from '../utilities/Updates';
import { Plugins } from '@capacitor/core';
import {Toolbar} from "./Toolbar";
const { Geolocation } = Plugins;

export default function Debug() {
  // const [debug, setDebug] = useState();
  // const [updates, setUpdates] = useState();

  // useEffect(() => {
  //   getStoredArray('processedUpdates').then(result => {
  //     setUpdates(result);
  //   });
  //   getStoredArray('debug').then(result => {
  //     setDebug(result);
  //   });
  // }, []);

  // if (!debug || !updates) {
  //   return null;
  // }

  // const debugItems = [];
  // for (const i in debug.reverse()) {
  //   if (debugItems.length === 100) { break; }

  //   debugItems.push(
  //     <IonItem key={i}>        
  //       <IonLabel>
  //         {moment(debug[i].added).format('DD/MM/YY HH:mm:ss')} - {debug[i].value}
  //       </IonLabel>
  //     </IonItem>
  //   );
  // }

  // const updateItems = [];
  // for (const i in updates.reverse()) {
  //   if (updateItems.length === 100) { break; }
  //   const update = updates[i];

  //   updateItems.push(
  //     <IonItem key={i}>        
  //       <IonLabel>
  //         {moment(update.added).format('DD/MM/YY HH:mm:ss')} - {update.value.value.action}
  //       </IonLabel>
  //     </IonItem>
  //   );
  // }

  // const clearDebug = () => {

  // }

  const [data, setData] = useState({
    outstandingUpdates: 'unknown',
    lastLocationUpdate: 'unknown',
    lastCommonUpdate: 'unknown',
    latitude: 'unknown',
    longitude: 'unknown',
  });

  const getData = async () => {

    const updates = await getUpdates();
    const coordinates = await Geolocation.getCurrentPosition();
    const llu = await getKey('lastLocationUpdate', '1899-01-01 00:00:00');
    const lcu = await getKey('lastCommonUpdate', '1899-01-01 00:00:00');

    setData({
      outstandingUpdates: updates.length,
      lastLocationUpdate: llu,
      lastCommonUpdate: lcu,
      latitude: coordinates.coords.latitude,
      longitude: coordinates.coords.longitude,
    });

  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="Debuggerator" backButtonHref="/" />
      </IonHeader>
      <IonContent className="ion-padding">
        <IonButton onClick={getData}>refresh</IonButton>
        outstandingUpdates {data.outstandingUpdates}<br />
        lastLocationUpdate {data.lastLocationUpdate}<br />
        lastCommonUpdate {data.lastCommonUpdate}<br />
        latitude {data.latitude}<br />
        longitude {data.longitude}
        {/* <IonButton onClick={clearDebug}>
          clear debug information
        </IonButton>
        <h3>updates</h3>
        <IonList>
        {updateItems}
        </IonList>
        <h3>debug</h3>
        <IonList>
        {debugItems}
        </IonList> */}
      </IonContent>
    </IonPage>
  );
}
